import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { General } from '../../interfaces/general';
import { FormGroup } from '@angular/forms';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: 'app-padre',
	templateUrl: './padre.component.html',
	styleUrls: ['./padre.component.css']
})
export class PadreComponent implements OnInit {
	@Input() catalogos: General;
	@Input() estados: Array<any>;
	@Input() DatosPadre: FormGroup;
	@Input() curpSolicitante: string
	@Input() listaCURPS: Array<any>
	@Output() conCurp = new EventEmitter()
	loading = false;
	tieneCURP = false;
	paises: any;
	tipoPersona = 1;
	extranjeroEs = false;
	pais: string;
	municipios: Array<any>;

	constructor(private serviciosGenerales: ServiciosGeneralesService,
				private snackBar: MatSnackBar) {}

	ngOnInit(): void {
		this.escucharCURP()
		this.listarMunicipios(this.DatosPadre.value.Personas_EntidadFederativaID)
		console.log(this.DatosPadre.value)
		this.DatosPadre.get('Personas_Nombre').disable()
		this.DatosPadre.get('Personas_Nombre').disable()
		this.DatosPadre.get('Personas_ApellidoPaterno').disable()
		this.DatosPadre.get('Personas_ApellidoMaterno').disable()
		this.DatosPadre.get('Personas_Genero').disable()
		this.DatosPadre.get('Personas_EntidadFederativaID').disable()
		this.DatosPadre.get('Personas_MunicipioID').disable()
		this.obtenerMunicipios()
	}
	ngOnChanges(changes) {
		console.log('padre')
		console.log()
		// if(this.DatosPadre.get('Direcciones_EntidadFederativaID').value !== null) {
		// 	this.listarMunicipios(this.DatosPadre.get('Direcciones_EntidadFederativaID').value)

		// }
	}
	escucharCURP() {
		this.DatosPadre.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				return CURP.length === 18 &&
						this.listaCURPS.filter(value => value === CURP).length === 0 &&
						this.curpSolicitante !== CURP
										? this.obtenerdatosCURP(CURP) :
										this.openSnackBar('Esta CURP ya fue registrada en esta solicitud','Entendido');
			});
	}

	obtenerMunicipios () {
		this.DatosPadre.get('Direcciones_EntidadFederativaID').valueChanges.subscribe(res => {
			console.log(res)
			this.listarMunicipios(res)
		})
	}
	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.DatosPadre.get("Personas_PaisID").setValue(pais.ID);
		});
	}
	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		console.log(idEstadoDB)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.DatosPadre.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.DatosPadre.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	listarMunicipios(idEstado: number) {

		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.cleanForm();
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {

				this.tieneCURP = res.Ok;
				if(this.tieneCURP && +res.Data.StateId !== 9999 && +res.Data.CityId !== 999) {
					if(res.Data.Genre === 'H') {
						if(res.Data.Country === "MEX") {

							this.mostrarInformacion(res.Data)
							// this.obtenerListaEstadosID()
							this.extranjeroEs = false;
						} else {
							this.pais = res.Data.Country
							this.extranjeroEs = true;
							this.mostrarInformacion(res.Data)
							this.obtenerPaises();
						}
					}
					else {
						this.openSnackBar('La CURP ingresada debe pertenecer a un Hombre', 'Entendido')
					}

				} else {
					this.openSnackBar('Tu CURP presenta inconsistencias en el sistema, favor de ponerte en contacto con EDUCAFIN.','Entendido')
				}
		})
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}
	mostrarInformacion(persona) {

		console.log(persona)
		if (persona !== undefined) {
			if(persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			}
			else {
				this.DatosPadre.get('Personas_EntidadFederativaID').setValue(1001);
			}
			this.getFecha(persona.BirthDate)
			this.DatosPadre.get('Personas_Nombre').setValue(persona.Name);
			this.DatosPadre.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.DatosPadre.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			this.DatosPadre.get('Personas_Genero').setValue(persona.Genre);
			this.conCurp.emit()
		}
	}
	getFecha (fecha:string) {
		const datos = fecha.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]
		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		this.DatosPadre.get('Personas_FechaNacimiento').setValue(nuevaFecha)
		const fechaCumpleanos = this.calculateAge(new Date(+ano,+mes,+dia))
		this.DatosPadre.get('Personas_Edad').setValue(fechaCumpleanos)
	}
	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}

	cleanForm(){
		this.DatosPadre.get('Personas_EstadoCivilID').setValue(0);
	}

}
